module.exports = __webpack_public_path__ + "static/media/anker-soundcore-life-q20.e564e59a.jpg";